const rowTransitionDurationMs = 250;
const wrapperCls = "c2lw9w18e4";
const bodyCls = "c2lb1k2ctr";
const transitionableRowCls = "c2lt2aoreg";

export { bodyCls, rowTransitionDurationMs, transitionableRowCls, wrapperCls };
import "./course-list.style.linaria.module.css";
//# sourceMappingURL=course-list.style.js.map
